import * as React from 'react';
import * as styles from "./NewComment.css";
import "../../../styles/BasicIA.css";
import { Helper } from '../../../Helper';

import { IReply } from '../../../interfaces/IReply';
import { IUser } from '../../../interfaces/IUser';
import { LocalizationService } from '../../../services/LocalizationService';
import { Environment } from '../../../services/Environment';
import ReactQuill from 'react-quill-with-table';
import { IATextField } from '../../textField/TextField';
import { IACheckbox } from '../../checkbox/Checkbox';
import { IAButton } from '../../button/Button';
import EmojiPicker from 'emoji-picker-react';
import SocialService from '../../../services/SocialService';
import { IASpinner } from '../../spinner/Spinner';

export interface INewCommentProps {
  token: string;
  tenant: string;
  environment: "Development" | "Test" | "Production";
  imageUploadUrl: string;
  buttonColor: string;
  reply: IReply;
  addComment: boolean;
  isMobile: boolean;
  dataAutomationIdPrefix?: string;
  comment: (comment: string, mentions: IUser[], reply?: IReply) => Promise<void>;
  cancelReply: () => void;
  newCommentPopupIsShowing: (isShowing: boolean) => void;
  isWriting: () => void;
  user?: any;
  highlightColor: string;
}

export interface INewCommentState {
  editor: any;
  allowPost: boolean;
  textSelection?: any;
  showLinkEditor: boolean;
  linkEditorRange?: any;
  linkEditorTarget?: any;
  linkEditorUrl?: any;
  linkEditorTitle?: any;
  currentRange?: any;
  showEmojiPicker: boolean;
  showImagePicker: boolean;
  cursorPositionLeft?: number;
  cursorPositionTop?: number;
  url?: string;
  isLoadingPreview: boolean;
  isDragging: boolean;
}

export class IANewComment extends React.Component<INewCommentProps, INewCommentState> {

  private reactQuillRef;
  private inputRef: React.RefObject<HTMLInputElement>

  constructor(props: INewCommentProps) {
    super(props);
    this.state = {
      editor: undefined,
      allowPost: false,
      showLinkEditor: false,
      showEmojiPicker: false,
      showImagePicker: false,
      isLoadingPreview: false,
      isDragging: false,
    };
    this.inputRef = React.createRef();
  }

  public componentWillReceiveProps(props: INewCommentProps): void {
    if (!props.addComment) {
      if (props.reply != undefined && props.reply != this.props.reply) {
        var div = document.getElementById('newComment');
        setTimeout(() => {
          if (div) {
            div.focus();
          };
        }, 0);
      }
      if (props.addComment != undefined && props.addComment != this.props.addComment) {
        var div = document.getElementById('newComment');
        setTimeout(() => {
          if (div) {
            div.focus();
          }
        }, 0);
      }
    }
  }

  public render(): JSX.Element {
    let firstNameChar = this.props.user?.displayName != undefined ? this.props.user?.displayName?.split(" ")[0].charAt(0) : "";
    let lastNameChar = this.props.user?.displayName != undefined ? this.props.user?.displayName?.split(" ")[this.props.user?.displayName?.split(" ").length - 1].charAt(0) : "";
    let toolTipContentElement = document.getElementById("IA_EmojiPicker");
    if (!toolTipContentElement) {
      toolTipContentElement = document.getElementById("IA_LinkEditor");
    }
    if (!toolTipContentElement) {
      toolTipContentElement = document.getElementById("IA_ImagePicker");
    }
    let cursorPositionTop = this.state.cursorPositionTop;
    let cursorPositionLeft = this.state.cursorPositionLeft;
    if (toolTipContentElement) {
      if (cursorPositionTop + toolTipContentElement.clientHeight > window.innerHeight) {
        cursorPositionTop -= toolTipContentElement.clientHeight + 20;
      }
      if (cursorPositionLeft + toolTipContentElement.clientWidth > window.innerWidth) {
        cursorPositionLeft = window.innerWidth - (toolTipContentElement.clientWidth / 2);
      }
    }
    return (
      <div
        className={styles.IA_newComment}
        style={{
          height: "auto",
          marginBottom: this.props.isMobile ? 100 : 20
        }}
      >
        <div>
          <div id="newComment">
            {this.props.reply &&
              <div
                style={{
                  marginBottom: 10
                }}
              >
                {`${new LocalizationService().strings.LikesAndComments_ReplyTo} ${this.props.reply.user?.displayName}:`}
              </div>
            }
            <div style={{ display: this.props.addComment ? "" : "none" }}>
              <div>
                <div
                  className={styles.IA_commentProfileImageWrapper}
                  style={{
                    backgroundColor: this.props.highlightColor != undefined ? this.props.highlightColor : "#333333",
                    color: this.props.highlightColor != undefined ? Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.highlightColor, "#ffffff", "#333333") : "#ffffff"
                  }}
                >
                  <div className={styles.IA_commentProfileImageText}>
                    {firstNameChar + lastNameChar}
                  </div>
                  <div
                    className={styles.IA_commentProfileImagePicture}
                    style={{
                      backgroundImage: `url('${Helper.getProfileImageUrlFromImageAPI(Environment.getEnvironmentForImageAPI(this.props.environment),
                        this.props.tenant, this.props.token, this.props.user?.userPrincipalName)}')`
                    }}
                  />
                </div>
                <div style={{
                  float: "left",
                  width: "calc(100% - 45px)",
                  padding: "5px 0px 10px 5px",
                  backgroundColor: "#ffffff",
                  marginTop: 8
                }}
                  onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
                    event.stopPropagation();
                  }}>
                  <div
                    id={`toolbar`}
                    style={{
                      display: "none"
                    }}
                  >
                    {/* Emoji */}
                    <svg
                      onClick={(event) => {
                        this.setState({
                          cursorPositionLeft: event.clientX,
                          cursorPositionTop: event.clientY,
                          showEmojiPicker: !this.state.showEmojiPicker
                        })
                        this.reactQuillRef.focus();
                        const textSelection = window.getSelection();
                        const linkEditorRange = textSelection?.rangeCount > 0 && textSelection?.getRangeAt(0);
                        setTimeout(() => {
                          this.setState({
                            textSelection,
                            linkEditorRange
                          });
                          this.reactQuillRef.focus();
                        }, 0);
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      width={this.props.isMobile ? 27 : 22}
                      height={this.props.isMobile ? 27 : 22}
                      viewBox="0 0 48 48"
                      fill="none"
                      style={{
                        marginTop: 0,
                        float: "left",
                        cursor: "pointer"
                      }}
                    >
                      <path d="M17.5 22C18.8807 22 20 20.8807 20 19.5C20 18.1193 18.8807 17 17.5 17C16.1193 17 15 18.1193 15 19.5C15 20.8807 16.1193 22 17.5 22ZM33 19.5C33 20.8807 31.8807 22 30.5 22C29.1193 22 28 20.8807 28 19.5C28 18.1193 29.1193 17 30.5 17C31.8807 17 33 18.1193 33 19.5ZM18.4519 34.6812C20.1644 35.5709 22.07 36.0239 23.9996 36C25.9292 36.0239 27.8349 35.5709 29.5473 34.6812C31.2597 33.7915 32.7259 32.4926 33.8156 30.9C33.9889 30.6177 34.043 30.2781 33.9659 29.9559C33.8888 29.6337 33.6869 29.3553 33.4046 29.182C33.1223 29.0087 32.7827 28.9546 32.4605 29.0317C32.1383 29.1088 31.8599 29.3107 31.6866 29.593C30.8212 30.8219 29.6683 31.8203 28.3284 32.5013C26.9885 33.1823 25.5024 33.5252 23.9996 33.5C22.4969 33.5246 21.011 33.1815 19.6712 32.5005C18.3315 31.8196 17.1784 30.8214 16.3126 29.593C16.2268 29.4532 16.1143 29.3317 15.9815 29.2354C15.8487 29.1391 15.6983 29.0699 15.5387 29.0317C15.3792 28.9935 15.2137 28.9872 15.0517 29.0129C14.8897 29.0387 14.7344 29.0962 14.5946 29.182C14.4548 29.2678 14.3333 29.3803 14.237 29.5131C14.1407 29.6459 14.0715 29.7963 14.0333 29.9559C13.9951 30.1154 13.9888 30.2809 14.0146 30.4429C14.0403 30.6049 14.0978 30.7602 14.1836 30.9C15.2733 32.4926 16.7395 33.7915 18.4519 34.6812ZM24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4ZM6.5 24C6.5 14.335 14.335 6.5 24 6.5C33.665 6.5 41.5 14.335 41.5 24C41.5 33.665 33.665 41.5 24 41.5C14.335 41.5 6.5 33.665 6.5 24Z" fill="#212121" />
                    </svg>
                    {/* Link */}
                    <svg
                      onClick={(event) => {
                        this.reactQuillRef.focus();
                        const textSelection = window.getSelection();
                        const linkEditorRange = textSelection?.rangeCount > 0 && textSelection?.getRangeAt(0);
                        this.setState({
                          textSelection,
                          showLinkEditor: !this.state.showLinkEditor,
                          linkEditorRange,
                          cursorPositionLeft: event.clientX,
                          cursorPositionTop: event.clientY,
                        }, () => {
                          if (this.state.showLinkEditor && textSelection?.rangeCount) {
                            const parent: any = textSelection.anchorNode.parentElement;
                            const anchor: any = textSelection.anchorNode;
                            if (parent || anchor) {
                              this.setState({
                                linkEditorTarget: parent.target != undefined ? parent.target : "_blank",
                                linkEditorUrl: parent.href != undefined ? parent.href : anchor.href,
                                linkEditorTitle: linkEditorRange?.cloneContents().textContent
                              });
                            } else {
                              this.setState({
                                linkEditorTitle: linkEditorRange?.cloneContents().textContent
                              });
                            }
                          }
                        });
                      }}
                      width={this.props.isMobile ? 27 : 22}
                      height={this.props.isMobile ? 27 : 22}
                      viewBox="0 0 48 48"
                      fill="none"
                      style={{
                        marginTop: 0,
                        float: "left",
                        cursor: "pointer",
                        marginLeft: this.props.isMobile ? 10 : 5
                      }}
                    >
                      <path d="M34 14C39.5228 14 44 18.4772 44 24C44 29.4292 39.6733 33.8479 34.2799 33.9962L34 34H28.25C27.5596 34 27 33.4404 27 32.75C27 32.1028 27.4919 31.5705 28.1222 31.5065L28.25 31.5H34C38.1421 31.5 41.5 28.1421 41.5 24C41.5 19.9391 38.2725 16.632 34.2427 16.5039L34 16.5H28.25C27.5596 16.5 27 15.9404 27 15.25C27 14.6028 27.4919 14.0705 28.1222 14.0065L28.25 14H34ZM19.75 14C20.4404 14 21 14.5596 21 15.25C21 15.8972 20.5081 16.4295 19.8778 16.4935L19.75 16.5H14C9.85786 16.5 6.5 19.8579 6.5 24C6.5 28.0609 9.72747 31.368 13.7573 31.4961L14 31.5H19.75C20.4404 31.5 21 32.0596 21 32.75C21 33.3972 20.5081 33.9295 19.8778 33.9935L19.75 34H14C8.47715 34 4 29.5228 4 24C4 18.5708 8.32667 14.1521 13.7201 14.0038L14 14H19.75ZM13 22.75H35C35.6904 22.75 36.25 23.3096 36.25 24C36.25 24.6472 35.7581 25.1795 35.1278 25.2435L35 25.25H13C12.3096 25.25 11.75 24.6904 11.75 24C11.75 23.3528 12.2419 22.8205 12.8722 22.7565L13 22.75H35H13Z" fill="#212121" />
                    </svg>
                    {/* Image */}
                    <svg
                      onClick={(event) => {
                        this.reactQuillRef.focus();
                        const textSelection = window.getSelection();
                        const linkEditorRange = textSelection?.rangeCount > 0 && textSelection?.getRangeAt(0);
                        this.setState({
                          textSelection,
                          showImagePicker: !this.state.showImagePicker,
                          linkEditorRange,
                          cursorPositionLeft: event.clientX,
                          cursorPositionTop: event.clientY,
                        });
                        setTimeout(() => {
                          this.forceUpdate();
                        }, 0);
                      }}
                      width={this.props.isMobile ? 27 : 22}
                      height={this.props.isMobile ? 27 : 22}
                      viewBox="0 0 48 48"
                      fill="none"
                      style={{
                        marginTop: 0,
                        float: "left",
                        cursor: "pointer",
                        marginLeft: this.props.isMobile ? 10 : 5
                      }}
                    >
                      <path d="M6 12.25C6 8.79822 8.79822 6 12.25 6H35.75C39.2018 6 42 8.79822 42 12.25V35.75C42 39.2018 39.2018 42 35.75 42H12.25C8.79822 42 6 39.2018 6 35.75V12.25ZM12.25 8.5C10.1789 8.5 8.5 10.1789 8.5 12.25V35.75C8.5 36.3457 8.6389 36.909 8.88608 37.4092L21.3669 25.0926C22.8269 23.6518 25.1735 23.6514 26.634 25.0916L39.1176 37.4018C39.3625 36.9034 39.5 36.3428 39.5 35.75V12.25C39.5 10.1789 37.8211 8.5 35.75 8.5H12.25ZM37.3312 39.1513L24.8786 26.8717C24.3918 26.3916 23.6096 26.3917 23.1229 26.872L10.6763 39.1548C11.1549 39.3764 11.688 39.5 12.25 39.5H35.75C36.315 39.5 36.8507 39.3751 37.3312 39.1513ZM30.5 19.5C29.3954 19.5 28.5 18.6046 28.5 17.5C28.5 16.3954 29.3954 15.5 30.5 15.5C31.6046 15.5 32.5 16.3954 32.5 17.5C32.5 18.6046 31.6046 19.5 30.5 19.5ZM30.5 22C32.9853 22 35 19.9853 35 17.5C35 15.0147 32.9853 13 30.5 13C28.0147 13 26 15.0147 26 17.5C26 19.9853 28.0147 22 30.5 22Z" fill="#212121" />
                    </svg>
                  </div>
                  <ReactQuill
                    ref={(el) => { this.reactQuillRef = el }}
                    value={this.state.editor ? this.state.editor : ""}
                    onChange={(html) => {
                      html = html.replace(/<undefined>/g, '<p>');
                      html = html.replace(/<\/undefined>/g, '</p>');
                      html = html.replace("XXXXXXXXXX", "");
                      if (html === "<p><br></p>") {
                        html = "";
                      }
                      if (html.includes("</p><p><br></p>")) {
                        html = html.replace("</p><p><br></p>", "</p>");
                      }
                      this.setState({ editor: html, allowPost: html !== undefined && html !== "" });
                    }}
                    onFocus={() => {
                      const toolbar: any = document.getElementsByClassName("ql-snow")[0];
                      toolbar.style.display = "block";
                    }}
                    onBlur={() => {
                      const toolbar: any = document.getElementsByClassName("ql-snow")[0];
                      toolbar.style.display = "none";
                    }}
                    modules={{
                      toolbar: {
                        container: `#toolbar`,
                      },
                      clipboard: {
                        matchVisual: false
                      }
                    }}
                    onChangeSelection={(e) => {
                      // Check if selection i a link
                      if (!this.state.showLinkEditor && !this.state.showEmojiPicker) {
                        if (this.state.editor) {
                          const textSelection = window.getSelection();
                          this.setState({
                            currentRange: e,
                            textSelection,
                            linkEditorRange: textSelection?.rangeCount > 0 && textSelection?.getRangeAt(0)
                          });
                          if (textSelection && textSelection?.rangeCount) {
                            // this.state.linkEditorTitle = this.state.linkEditorRange.cloneContents().textContent;
                            const parent: any = textSelection.anchorNode.parentElement;
                            // Existing link
                            if (parent && parent instanceof HTMLAnchorElement) {
                              let linkEditorTitle;
                              if (!this.state.linkEditorTitle) {
                                linkEditorTitle = parent.innerText;
                              }
                              this.setState({
                                linkEditorTarget: parent.target != undefined ? parent.target : "_blank",
                                linkEditorUrl: parent.href,
                                linkEditorTitle
                              });
                              let body: any = document.body;
                              let range;
                              if (body.createTextRange) {
                                range = body.createTextRange();
                                range.moveToElementText(parent);
                                range.select();
                              }
                            } else {
                              this.setState({
                                showLinkEditor: false,
                                linkEditorTarget: undefined,
                                linkEditorUrl: undefined,
                                linkEditorTitle: undefined
                              });
                            }
                          }
                        }
                      } else {
                        if (this.state.currentRange && e && e.length === 0 && (e.index < this.state.currentRange.index || this.state.currentRange && e && e.index > this.state.currentRange.index + this.state.currentRange.length)) {
                          this.setState({
                            showLinkEditor: false,
                            linkEditorTarget: undefined,
                            linkEditorUrl: undefined,
                            linkEditorTitle: undefined
                          });
                        }
                      }
                    }}
                    placeholder={new LocalizationService().strings.CommentsAndLikes_AddComment}
                  />
                </div>
              </div>
            </div>
            <div
              className={styles.IA_postBtn}
              data-automation-id={`${this.props.dataAutomationIdPrefix}-new`}
              onClick={() => {
                if (this.state.allowPost) {
                  // Mentions
                  let mentions: IUser[] = [];
                  var contentDiv: any = document.createElement('div');
                  contentDiv.innerHTML = this.state.editor;
                  contentDiv.innerHTML = contentDiv.innerHTML.replace(new RegExp(`"`, 'g'), `'`);
                  contentDiv.innerHTML = contentDiv.innerHTML.replace(new RegExp(`//www.y`, 'g'), `https://www.y`);
                  let mentionElements = contentDiv.getElementsByClassName("ia_mention");
                  for (let i = 0; i < mentionElements.length; i++) {
                    mentions.push(
                      {
                        userPrincipalName: mentionElements[i].getAttribute("id").toLowerCase(),
                        displayName: mentionElements[i].innerText
                      }
                    );
                  }
                  // Images
                  let images = contentDiv.getElementsByTagName("img");
                  for (let i = 0; i < images.length; i++) {
                    let src = images[i].src;
                    if (src.indexOf("intraactive-image-functions") != -1) {
                      let sharepointImageUrl = decodeURIComponent(src.split("path=")[1]);
                      contentDiv.getElementsByTagName("img")[i].src = sharepointImageUrl;
                    }
                  }
                  // Save
                  // let iframe: any = document.getElementsByClassName("tox-edit-area__iframe")[0];
                  // iframe.focus();
                  let activeElement: any = document.activeElement;
                  activeElement.blur();
                  this.setState({ allowPost: false });
                  this.props.newCommentPopupIsShowing(false);
                  this.props.comment(contentDiv.innerHTML, mentions, this.props.reply).then(() => {
                    this.setState({ editor: "" })
                  });
                }
              }}
              style={{
                backgroundColor: this.state.editor != undefined && this.state.editor != "" ? this.props.buttonColor : "#e3e3e3",
                color: this.state.editor != undefined && this.state.editor != "" ? Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.buttonColor, "#ffffff", "#333333") : "gray",
                visibility: this.props.addComment ? "visible" : "hidden",
                display: this.props.addComment && this.state.editor ? "" : "none"
              }}
            >
              {new LocalizationService().strings.LikesAndComments_NewComment_AddComment}
            </div>
            {this.props.addComment &&
              <div
                className={styles.IA_cancelBtn}
                data-automation-id={`${this.props.dataAutomationIdPrefix}-cancel`}
                onClick={() => {
                  this.setState({ editor: "", allowPost: false });
                  this.props.newCommentPopupIsShowing(false);
                  // let iframe: any = document.getElementsByClassName("tox-edit-area__iframe")[0];
                  // iframe.focus();
                  let activeElement: any = document.activeElement;
                  activeElement.blur();
                  this.props.cancelReply();
                }}
                style={{
                  backgroundColor: "gray",
                  color: "#ffffff",
                  display: (this.state.allowPost && this.state.editor || this.props.reply) ? "" : "none"
                }}
              >
                {new LocalizationService().strings.LikesAndComments_NewComment_Cancel}
              </div>
            }
            {(this.state.showEmojiPicker || this.state.showLinkEditor || this.state.showImagePicker) &&
              <div
                className={styles.IA_linkBackground}
                style={{
                  backgroundColor: this.props.isMobile ? "#ffffff80" : "transparent"
                }}
                onClick={() => {
                  this.setState({ showLinkEditor: false, showEmojiPicker: false, showImagePicker: false });
                  this.reactQuillRef.focus();
                }}
              />
            }

            {/* TOOLS */}
            {this.state.showEmojiPicker &&
              <div
                id="IA_EmojiPicker"
                style={{
                  position: "fixed",
                  top: this.props.isMobile ? undefined : cursorPositionTop,
                  bottom: this.props.isMobile ? 80 : undefined,
                  left: this.props.isMobile ? "20px" : cursorPositionLeft,
                  width: this.props.isMobile ? "calc(100% - 40px)" : 420
                }}>
                <EmojiPicker
                  searchPlaceHolder={new LocalizationService().strings.LikesAndComments_Emoji_Search}
                  onEmojiClick={(emoji) => {
                    if (this.state.linkEditorRange) {
                      this.state.linkEditorRange.deleteContents();
                      this.state.linkEditorRange.insertNode(document.createTextNode(emoji.emoji));
                      this.setState({
                        showEmojiPicker: false,
                        textSelection: undefined
                      })
                    }
                    console.log(emoji.emoji);
                  }}
                />
              </div>
            }
            {this.state.showLinkEditor &&
              <div
                id="IA_LinkEditor"
                className={styles.IA_linkBox}
                style={{
                  position: "fixed",
                  top: this.props.isMobile ? undefined : cursorPositionTop,
                  bottom: this.props.isMobile ? 80 : undefined,
                  left: this.props.isMobile ? "20px" : cursorPositionLeft,
                  width: this.props.isMobile ? "calc(100% - 40px)" : 420
                }}
              >
                <IATextField
                  label={new LocalizationService().strings.Composer_URL}
                  text={this.state.linkEditorUrl}
                  style={{
                    marginTop: 20
                  }}
                  inputFieldStyle={{
                    backgroundColor: "#f6f6f6",
                    border: "none"
                  }}
                  labelStyle={{
                    color: "#858585",
                    fontWeight: 700,
                    fontSize: 12
                  }}
                  borderRadius={8}
                  onChange={(linkEditorUrl: string) => {
                    this.setState({ linkEditorUrl });
                  }}
                />
                <IATextField
                  label={new LocalizationService().strings.Composer_LinkText}
                  text={this.state.linkEditorTitle}
                  style={{
                    marginTop: 20,
                  }}
                  labelStyle={{
                    color: "#858585",
                    fontWeight: 700,
                    fontSize: 12
                  }}
                  inputFieldStyle={{
                    backgroundColor: "#f6f6f6",
                    border: "none"
                  }}
                  onChange={(linkEditorTitle: string) => {
                    this.setState({ linkEditorTitle });
                  }}
                  borderRadius={8}
                />
                <IACheckbox
                  highlightColor={this.props.highlightColor}
                  isChecked={this.state.linkEditorTarget === "_blank"}
                  label={new LocalizationService().strings.Composer_OpenInNewTab}
                  onChange={() => {
                    this.setState({ linkEditorTarget: this.state.linkEditorTarget === "_blank" ? "_self" : "_blank" });
                  }}
                  styles={{
                    float: "left",
                    marginTop: 20,
                  }}
                />
                <IAButton
                  label={new LocalizationService().strings.Composer_AddLink}
                  buttonColor={this.props.highlightColor}
                  disbaled={(this.state.linkEditorUrl == undefined || this.state.linkEditorUrl === "") && (this.state.linkEditorTitle && undefined || this.state.linkEditorTitle === "")}
                  onClick={() => {
                    if (this.state.linkEditorRange) {
                      this.state.linkEditorRange.deleteContents();
                      var a = document.createElement('a');
                      var linkText = document.createTextNode(this.state.linkEditorTitle);
                      a.appendChild(linkText);
                      a.title = this.state.linkEditorTitle;
                      a.target = this.state.linkEditorTarget;
                      a.href = this.state.linkEditorUrl;
                      a.setAttribute("data-interception", "off");
                      this.state.linkEditorRange.insertNode(a);
                      this.setState({
                        showLinkEditor: false,
                        textSelection: undefined
                      })
                      setTimeout(() => {
                        this.reactQuillRef.focus();
                      }, 0);
                    }
                  }}
                  borderRadius={8}
                  style={{
                    marginTop: 20,
                    clear: "both",
                    float: "left",
                    opacity: (this.state.linkEditorUrl == undefined || this.state.linkEditorUrl === "") && (this.state.linkEditorTitle && undefined || this.state.linkEditorTitle === "") ? 0.5 : 1
                  }}
                />
              </div>
            }
            {this.state.showImagePicker &&
              <div
                id="IA_ImagePicker"
                className={styles.IA_linkBox}
                style={{
                  position: "fixed",
                  top: this.props.isMobile ? undefined : cursorPositionTop,
                  bottom: this.props.isMobile ? 80 : undefined,
                  left: this.props.isMobile ? "20px" : cursorPositionLeft,
                  height: 290,
                  width: this.props.isMobile ? "calc(100% - 40px)" : 420
                }}
              >
                <div
                  className={styles.IA_uploadContainer}
                  style={{
                    backgroundColor: '#fafafa',
                    border: this.state.url == undefined ? `1px dashed ${this.props.highlightColor}` : "none",
                    opacity: this.state.isDragging ? 0.5 : 1,
                    borderRadius: this.state.url == undefined ? 8 : 0
                  }}
                >
                  {this.state.url ?
                    <div
                      className={styles.IA_imagePreview}
                      style={{
                        backgroundImage: `url("${Helper.getImageUrl(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, this.state.url, undefined, "Full")}")`
                      }}
                    >

                    </div>
                    :
                    (this.state.isLoadingPreview ?
                      <IASpinner
                        color={this.props.highlightColor}
                        style={{
                          position: "absolute",
                          left: "calc(50% - 15px)",
                          margin: 0
                        }}
                      />
                      :
                      <>
                        <p
                          className={styles.IA_dragDropText}
                          style={{
                            color: this.props.highlightColor
                          }}
                        >
                          Drop your image here or click to select a file
                        </p>
                        <input
                          ref={this.inputRef}
                          className={styles.IA_uploadInput}
                          type="file"
                          accept={'image/*'}
                          onLoad={() => this.setState({ isLoadingPreview: false })}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            if (e.target.files) {
                              this.setState({ isLoadingPreview: true });
                              SocialService.uploadSelecedImage(e.target.files[0], this.props.imageUploadUrl, this.props.token).then((imageUrl: string) => {
                                this.setState({ url: imageUrl, isLoadingPreview: false });
                              });
                            }
                          }}
                          onDragOver={e => {
                            if (e.dataTransfer?.items && e.dataTransfer?.items?.length > 0 && !this.state.isDragging) {
                              this.setState({ isDragging: true });
                            }
                          }}
                          onDragLeave={() => {
                            if (this.state.isDragging) {
                              this.setState({ isDragging: false });
                            }
                          }}
                          onDrop={() => {
                            this.setState({ isDragging: false });
                          }}
                        />
                      </>
                    )
                  }
                </div>
                <IAButton
                  label={"Add image"}
                  disbaled={this.state.url == undefined}
                  buttonColor={this.props.highlightColor}
                  borderRadius={8}
                  onClick={() => {
                    if (this.state.linkEditorRange) {
                      this.state.linkEditorRange.deleteContents();
                      var img = document.createElement('img');
                      img.src = Helper.getImageUrl(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, this.state.url, undefined, "Full");
                      img.className = "editorImage";
                      this.state.linkEditorRange.insertNode(img);
                      this.setState({
                        showImagePicker: false,
                        textSelection: undefined
                      })
                      setTimeout(() => {
                        this.reactQuillRef.focus();
                      }, 0);
                    }
                  }}
                  style={{
                    marginTop: 20,
                    clear: "both",
                    float: "left",
                    opacity: this.state.url == undefined ? 0.5 : 1
                  }}
                />
                <IAButton
                  label={"Cancel"}
                  disbaled={this.state.url == undefined}
                  buttonColor={"gray"}
                  borderRadius={8}
                  onClick={() => this.setState({ url: undefined })}
                  style={{
                    marginTop: 20,
                    float: "left",
                    marginLeft: 10,
                    opacity: this.state.url == undefined ? 0.5 : 1
                  }}
                />
              </div>
            }
          </div>
        </div>
      </div >
    );
  }
}